 // @ts-nocheck
import moment from "moment";
import React from "react";

export default function CommonFooter({open}) {
  const url = "https://www.xome.com"
  const currentYear = moment().year() 
  return (
    <div className="mt-[264px] sm:mt-[12rem] lg:mt-24 xl:mt-20 flex">
    <div className={`bottom-0 absolute h-auto bg-white text-justify text-black py-2 sm:px-3 px-2 -ml-4`}>
      <p className="text-[14px] leading-[21px] font-medium text-[#3B3B3B]">
        <a href={`${url}/auctions/licensing`} target="_blank" className="underline underline-[#FF5C39] text-[#FF5C39] font-medium">
          Real Estate and Auction Licensing
        </a>
        © {currentYear} Xome Inc.; Xome Realty Services LLC; Xome CT LLC (Davis E. Owen,
        Sr.- Broker) (CT properties only); Xome PR LLC (PR properties only);
        Xome OH LLC (OH properties only). All rights reserved. 750 Highway 121
        Bypass, Suite 100, Lewisville, TX 75067. Use of this Website constitutes
        acceptance of the{" "}
        <a href={`${url}/pages/terms-of-use`} target="_blank" className="underline underline-[#FF5C39] text-[#FF5C39] font-medium">
          Terms of Use
        </a>{" "}
        and{" "}
        <a href={`${url}/pages/privacy-policy`} target="_blank" className="underline underline-[#FF5C39] text-[#FF5C39] font-medium">
          Privacy Policy
        </a>
        .
      </p>
      <p className="text-[14px] leading-[21px] font-medium text-[#3B3B3B]" >
      Money transmission services relating to the Passport Program are provided by Priority, directly or through its subsidiary Finxera, Inc. (NMLS #1168701) or its authorized affiliates and contractors.
      </p>
    </div>
    </div>
  );
}
